var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828384",
    d: "M18.012 8a1 1 0 0 0-2 0zm-14 0a1 1 0 0 0-2 0zm14.293 2.707a1 1 0 0 0 1.414-1.414zM10.012 1l.707-.707a1 1 0 0 0-1.414 0zM.305 9.293a1 1 0 1 0 1.414 1.414zM5.012 20h10v-2h-10zm13-3V8h-2v9zm-14 0V8h-2v9zM19.72 9.293l-9-9-1.414 1.414 9 9zm-10.414-9-9 9 1.414 1.414 9-9zM15.012 20a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1zm-10-2a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3z"
  })));
};
export default SvgHome;